import { mockClient } from './mock'
import { httpClient } from './client'
import type { ApiClient } from './types'

/**
 * 数据层开关。只改 .env.development 里的 VITE_API_MODE 即可切换：
 *   VITE_API_MODE=mock  → 纯前端假数据，链路完整可演示（默认）
 *   VITE_API_MODE=http  → 打你的 Python 后端（同源 /api/*，由 vite proxy 转发）
 */
export const API_MODE: 'mock' | 'http' = (import.meta.env.VITE_API_MODE ?? 'mock') === 'http' ? 'http' : 'mock'

export const api: ApiClient = API_MODE === 'http' ? httpClient : mockClient

export * from './types'
